// 全景预览模式
import { getQueryParams, NATIVE_MOCK } from '../../../utils';
import PanoramaMockData from '../api/mock';
import request from '../../../utils/request';
import { MessageTip } from '../../../utils/message';

function safeDecodeURIComponent(str) {
  if (!str) {
    return '';
  }
  try {
    return decodeURIComponent(str);
  } catch {
    return '';
  }
}

export function getPanoramaPreviewParams() {
  const { panoramaPreview, vrBase, mid, projectName, modulePath } = getQueryParams();
  if (panoramaPreview === 'true') {
    const decodeVrBase = safeDecodeURIComponent(vrBase);
    const decodeProjectName = safeDecodeURIComponent(projectName) || '预览项目';
    if (!decodeVrBase || !mid) {
      MessageTip.error('链接参数异常');
    }
    const base = decodeVrBase && mid ? `${decodeVrBase}/vr/${modulePath || mid}` : '';
    const configPath = decodeVrBase && mid ? `${decodeVrBase}/vr/config/${mid}.json` : '';
    const xmlName = decodeVrBase && mid ? `${decodeVrBase}/vr/${modulePath || mid}/tour.xml` : '';
    return {
      base,
      configPath,
      xmlName,
      projectName: decodeProjectName,
    };
  }
  return null;
}

export function getKrpanoMockData() {
  const urlPrefix = '%FIRSTXML%';

  const previewParams = getPanoramaPreviewParams();
  if (previewParams) {
    const { configPath, xmlName } = previewParams;
    return {
      configPath,
      xmlName,
      urlPrefix,
    };
  } else if (NATIVE_MOCK) {
    return {
      configPath: PanoramaMockData.panoConfigURL,
      xmlName: PanoramaMockData.xmlName,
      urlPrefix,
    };
  }
  return {};
}

export async function getMockConfigWithConvert() {
  const previewParams = getPanoramaPreviewParams();
  if (previewParams) {
    const { configPath, projectName } = previewParams;
    if (!configPath) {
      return;
    }
    const data: any = await request<any>({
      url: `${configPath}?t=${Date.now()}`,
      method: 'get',
    });
    data.project = {
      name: projectName,
    };
    return convertConfig(data);
  }
}

const ExportConfig = {
  placeholderPath: '${resource}',
};

function convertConfig(originModule: any) {
  if (!originModule) {
    return;
  }
  const module = originModule;
  module.scenes?.forEach((scene) => {
    if (scene.thumb) {
      scene.thumb = `${ExportConfig.placeholderPath}/${scene.thumb}`;
    }
  });
  module.groups?.forEach((group) => {
    const { floors = [] } = group;
    floors.forEach((floor) => {
      if (floor.map) {
        const pureMap = floor.map.replace(`${ExportConfig.placeholderPath}/vr/${module.modulePath || module.id}/`, '');
        floor.map = `${ExportConfig.placeholderPath}/${pureMap}`;
      }
    });
  });
  return module;
}
